
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarPerformanceMonitorIec as ObiRadarPerformanceMonitorIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-performance-monitor-iec.js';
 
 
 

 
 export const ObiRadarPerformanceMonitorIec = createComponent({
   react: React,
   tagName: 'obi-radar-performance-monitor-iec',
   elementClass: ObiRadarPerformanceMonitorIecElement,
   events: {
     
   }
  });
 
 